import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: {
                    seo: {
                        siteTitle: "Bousanm Technology",
                        defaultTitle: "Bousanm Technology - Global Logistics & Software",
                        defaultDescription: "Custom software development, e-commerce infrastructure, and global logistics solutions for emerging markets.",
                        defaultKeywords: "software development, logistics, shipping, e-commerce, Caribbean, Latin America, courier, freight forwarding"
                    },
                    nav: {
                        whatWeDo: "What we do",
                        overview: "Overview",
                        whoWeServe: "Who we serve",
                        aboutUs: "About Us",
                        compliance: "Compliance"
                    },
                    hero: {
                        badge: "Advanced Tech & Global Logistics",
                        headline: "Empowering Global Operations Through Technology & Logistics",
                        description_part1: "Bousanm Technology provides end-to-end software development, seamless e-commerce infrastructure, and robust shipping solutions.",
                        description_part2: "Tailored for emerging markets, our solutions ensure reliability and scale for your global business needs.",
                        waitlist: "Join the Waitlist",
                        contact: "Contact Us",
                        ukRegistered: "UK Registered",
                        licensed: "Licensed Partners",
                        secure: "Global Operations",
                        cardLabel: "TRACKING NUMBER",
                        businessName: "BSM-9920-X1"
                    },
                    features: {
                        title: "Our Services",
                        subtitle: "Empowering Global Operations Through Technology & Logistics",
                        description: "Bousanm Technology builds the foundation for your business growth through custom software, e-commerce, and logistics.",
                        sectionTitle: "Core Services",
                        card1_title: "Software Development",
                        card1_desc: "We build custom enterprise solutions, from fintech APIs to scalable ERP systems, helping businesses automate their core operations.",
                        card2_title: "Global Shipping & Logistics",
                        card2_desc: "Reliable courier and freight forwarding services connecting the USA, Latin America, and the Caribbean with real-time tracking.",
                        card3_title: "E-commerce Solutions",
                        card3_desc: "We provide the digital tools and payment infrastructure necessary for brands to scale in high-growth regions.",
                        card4_title: "Global Operations",
                        card4_desc: "Technology‑driven infrastructure to manage and scale your business operations anywhere in the world."
                    },
                    whyBousanm: {
                        title: "Why Bousanm Technology",
                        subtitle: "Built for Efficiency, Scale, and Results",
                        feature1: "Custom software architecture",
                        feature2: "Global logistics infrastructure",
                        feature3: "Designed for emerging markets",
                        feature4: "Secure and scalable platforms",
                        feature5: "24/7 technical and operational support",
                        tagline: "Technology you can trust. Infrastructure built to scale."
                    },
                    productOverview: {
                        title: "Coming Soon",
                        subtitle: "Expanding Our Ecosystem",
                        description: "We are constantly evolving our platform to bring more advanced features to our clients.",
                        feature1: "Integrated warehouse management",
                        feature2: "Advanced API integrations",
                        feature3: "Global fulfillment network",
                        footer: "More features launching soon."
                    },
                    whoWeServe: {
                        title: "Who we serve",
                        subtitle: "Tailored for Global Growth",
                        audience1_title: "Emerging Market Businesses",
                        audience1_desc: "Empowering local businesses with global tech and logistics capabilities.",
                        audience2_title: "E-commerce Brands & Startups",
                        audience2_desc: "Scalable infrastructure to launch and grow your online presence.",
                        audience3_title: "Logistics & Distribution Firms",
                        audience3_desc: "Modernizing the supply chain with data-driven software solutions."
                    },
                    waitlist: {
                        title: "Start Your Global Journey Today",
                        description: "Join our early access list and discover how our technology can transform your operations.",
                        emailPlaceholder: "Email address",
                        countryPlaceholder: "Country (optional)",
                        button: "Get Early Access",
                        privacy: "We respect your privacy. No spam.",
                        successTitle: "Welcome aboard!",
                        successMessage: "We'll be in touch soon with next steps."
                    },
                    compliance: {
                        title: "Reliability & Quality Standards",
                        description: "Our operations are built on a foundation of security, transparency, and excellence.",
                        point1_title: "Data Protection & Privacy",
                        point1_desc: "Your business data is secure with our enterprise-grade encryption.",
                        point2_title: "Transparent Logistics",
                        point2_desc: "Real-time tracking and reporting for all your shipping needs.",
                        point3_title: "Rigorous Tech Audits",
                        point3_desc: "Continuous software testing and security updates to ensure stability.",
                        point4_title: "Global Standards",
                        point4_desc: "Adhering to international best practices in software development and logistics.",
                        disclaimerTitle: "Our Commitment",
                        disclaimer1: "Bousanm Technology is a service and technology provider.",
                        disclaimer2: "We partner with local and international experts to deliver top-tier logistics.",
                        disclaimer3: "We are committed to empowering emerging markets through innovation."
                    },
                    footer: {
                        subtitle: "Tech & Logistics Infrastructure",
                        description: "Empowering businesses in emerging markets with end-to-end software, e-commerce, and shipping solutions.",
                        platform: "Platform",
                        legal: "Legal",
                        privacyPolicy: "Privacy Policy",
                        termsOfService: "Terms of Use",
                        copyright: "© 2026 Bousanm LLC. All rights reserved.",
                        disclaimer: "Bousanm Technology is a financial technology company, not a bank. Banking services are provided by our partner financial institutions.",
                        address: "Registered Address: 30 N Gould St Ste R, Sheridan, WY 82801 US",
                        contact: "support@bousanmtechnology.com"
                    },
                    about: {
                        title: "About Us",
                        subtitle: "Bridging the Infrastructure Gap",
                        content: "Bousanm Technology is a dual-headquartered firm (USA & UK) dedicated to bridging the infrastructure gap in emerging markets. Founded as part of the Zig Investment ecosystem, we leverage cutting-edge software to solve complex logistics and financial challenges. Our mission is to provide businesses in the Caribbean and Latin America with the technological backbone required to compete globally.",
                        visionTitle: "Global Vision",
                        visionContent: "Empowering brands in the Caribbean and Latin America to compete on the world stage.",
                        techTitle: "Robust Tech",
                        techContent: "Cutting-edge software solving the most complex logistics challenges."
                    }
                }
            },
            ht: {
                translation: {
                    seo: {
                        siteTitle: "Bousanm Technology",
                        defaultTitle: "Bousanm Technology - Lojistik Global ak Lojisyèl",
                        defaultDescription: "Devlopman lojisyèl sou mezi, enfrastrikti e-commerce, ak solisyon lojistik global pou mache k ap monte yo.",
                        defaultKeywords: "devlopman lojisyèl, lojistik, anbake, e-commerce, Karayib, Amerik Latin, kourye, machandiz"
                    },
                    nav: {
                        whatWeDo: "Sa nou fè",
                        overview: "Apèsi",
                        whoWeServe: "Kliyan nou yo",
                        aboutUs: "Konsènan nou",
                        compliance: "Konfòmite"
                    },
                    hero: {
                        badge: "Teknoloji Avanse ak Lojistik Global",
                        headline: "Ranfòse Operasyon Global atravè Teknoloji ak Lojistik",
                        description_part1: "Bousanm Technology bay devlopman lojisyèl bout-an-bout, enfrastrikti e-commerce san pwoblèm, ak solisyon anbakman solid.",
                        description_part2: "Adapte pou mache k ap devlope yo, solisyon nou yo garanti fyabilite ak kwasans pou tout bezwen biznis ou nan lemonn.",
                        waitlist: "Antre nan lis datant",
                        contact: "Kontakte Nou",
                        ukRegistered: "Anrejistre nan UK",
                        licensed: "Patnè ki gen lisans",
                        secure: "Operasyon Global",
                        cardLabel: "NIMEWO SUIVI",
                        businessName: "BSM-9920-X1"
                    },
                    features: {
                        title: "Sèvis Nou Yo",
                        subtitle: "Ranfòse Operasyon Global atravè Teknoloji ak Lojistik",
                        description: "Bousanm Technology bati baz pou kwasans biznis ou atravè lojisyèl koutim, e-commerce, ak lojistik.",
                        sectionTitle: "Sèvis Fondamantal",
                        card1_title: "Devlopman Lojisyèl",
                        card1_desc: "Nou bati solisyon antrepriz pèsonalize, soti nan API fintech rive nan sistèm ERP ki ka grandi, pou ede biznis otomatize operasyon prensipal yo.",
                        card2_title: "Expedisyon ak Lojistik Mondyal",
                        card2_desc: "Sèvis kourye ak transpò machandiz serye k ap konekte Etazini, Amerik Latin ak Karayib la ak swivi an tan reyèl.",
                        card3_title: "Solisyon E-commerce",
                        card3_desc: "Nou bay zouti dijital ak enfrastrikti peman ki nesesè pou mak yo ka grandi nan rejyon ki gen kwasans rapid.",
                        card4_title: "Operasyon Global",
                        card4_desc: "Enfrastrikti ki baze sou teknoloji pou jere ak devlope operasyon biznis ou nenpòt kote nan lemonn."
                    },
                    whyBousanm: {
                        title: "Poukisa Bousanm Technology",
                        subtitle: "Bati pou Efikasite, Echèl, ak Rezilta",
                        feature1: "Achitekti lojisyèl koutim",
                        feature2: "Enfrastrikti lojistik global",
                        feature3: "Konsepsyon pou mache emerjan",
                        feature4: "Platfòm sekirize ak evolyab",
                        feature5: "Sipò teknik ak operasyonèl 24/7",
                        tagline: "Teknoloji ou ka fè konfyans. Enfrastrikti bati pou grandi."
                    },
                    productOverview: {
                        title: "Ap Vini Byento",
                        subtitle: "Elaji Ekosistèm Nou An",
                        description: "N ap kontinye evolye platfòm nou an pou pote plis karakteristik avanse bay kliyan nou yo.",
                        feature1: "Jesyon depo entegre",
                        feature2: "Entegrasyon API avanse",
                        feature3: "Rezo distribisyon global",
                        footer: "Plis karakteristik ap vini byento."
                    },
                    whoWeServe: {
                        title: "Kliyan Nou Yo",
                        subtitle: "Adapte pou Kwasans Global",
                        audience1_title: "Biznis nan Mache Emerjan",
                        audience1_desc: "Ranfòse biznis lokal yo ak kapasite teknoloji ak lojistik mondyal.",
                        audience2_title: "Mak E-commerce ak Startup",
                        audience2_desc: "Enfrastrikti evolyab pou lanse ak devlope prezans ou sou entènèt.",
                        audience3_title: "Konpayi Lojistik ak Distribisyon",
                        audience3_desc: "Modènize chèn ekipman an ak solisyon lojisyèl ki baze sou done."
                    },
                    waitlist: {
                        title: "Kòmanse Vwayaj Global Ou Jodi a",
                        description: "Antre nan lis aksè bonè nou an epi dekouvri kijan teknoloji nou an ka transfòme operasyon ou yo.",
                        emailPlaceholder: "Adrès imel",
                        countryPlaceholder: "Peyi (opsyonèl)",
                        button: "Jwenn Aksè Bonè",
                        privacy: "Nou respekte konfidansyalite ou. Pa gen spam.",
                        successTitle: "Byenveni abò!",
                        successMessage: "N ap kontakte w talè pou pwochen etap yo."
                    },
                    compliance: {
                        title: "Estanda Fyabilite ak Kalite",
                        description: "Operasyon nou yo bati sou yon baz sekirite, transparans, ak ekselans.",
                        point1_title: "Pwoteksyon Done ak Konfidansyalite",
                        point1_desc: "Done biznis ou an sekirite avèk chifreman nivo antrepriz nou an.",
                        point2_title: "Lojistik Transparan",
                        point2_desc: "Suivi an tan reyèl ak rapò pou tout bezwen anbakman ou yo.",
                        point3_title: "Odit Teknik Rigoureux",
                        point3_desc: "Tès lojisyèl ak mizajou sekirite kontinyèl pou asire estabilite.",
                        point4_title: "Estanda Global",
                        point4_desc: "Respekte pi bon pratik entènasyonal nan devlopman lojisyèl ak lojistik.",
                        disclaimerTitle: "Angajman Nou",
                        disclaimer1: "Bousanm Technology se yon founisè sèvis ak teknoloji.",
                        disclaimer2: "Nou kolabore ak ekspè lokal ak entènasyonal pou bay pi bon lojistik.",
                        disclaimer3: "Nou pran angajman pou ranfòse mache emerjan yo atravè inovasyon."
                    },
                    footer: {
                        subtitle: "Enfrastrikti Teknoloji ak Lojistik",
                        description: "Ranfòse biznis yo nan mache emerjan yo ak lojisyèl bout-an-bout, e-commerce, ak solisyon anbakman.",
                        platform: "Platfòm",
                        legal: "Legal",
                        privacyPolicy: "Politik Konfidansyalite",
                        termsOfService: "Kondisyon Itilizasyon",
                        copyright: "© 2026 Bousanm LLC. Tout dwa rezève.",
                        disclaimer: "Bousanm Technology se yon konpayi teknoloji finansye, se pa yon bank. Sèvis bankè yo bay pa patnè enstitisyon finansye nou yo.",
                        address: "Adrès Anrejistre: 30 N Gould St Ste R, Sheridan, WY 82801 US",
                        contact: "support@bousanmtechnology.com"
                    },
                    about: {
                        title: "Konsènan Nou",
                        subtitle: "Konble Mank Enfrastrikti a",
                        content: "Bousanm Technology se yon konpayi ki gen de katye jeneral (USA ak UK) ki dedye pou konble mank enfrastrikti nan mache k ap devlope yo. Te fonde kòm pati nan ekosistèm Zig Investment, nou itilize lojisyèl avanse pou rezoud defi lojistik ak finansye ki konplèks. Misyon nou se bay biznis nan Karayib ak Amerik Latin baz teknolojik ki nesesè pou yo konpeti nan nivo mondyal.",
                        visionTitle: "Vizyon Global",
                        visionContent: "Ranfòse mak nan Karayib ak Amerik Latin pou yo ka konpeti nan nivo mondyal.",
                        techTitle: "Teknoloji Solid",
                        techContent: "Lojisyèl dènye kri k ap rezoud defi lojistik ki pi konplèks yo."
                    }
                }
            },
            fr: {
                translation: {
                    seo: {
                        siteTitle: "Bousanm Technology",
                        defaultTitle: "Bousanm Technology - Logistique Globale & Logiciels",
                        defaultDescription: "Développement de logiciels sur mesure, infrastructure e-commerce et solutions logistiques mondiales pour les marchés émergents.",
                        defaultKeywords: "développement de logiciels, logistique, expédition, e-commerce, Caraïbes, Amérique Latine, courrier, fret"
                    },
                    nav: {
                        whatWeDo: "Ce que nous faisons",
                        overview: "Aperçu",
                        whoWeServe: "Qui nous servons",
                        aboutUs: "À propos",
                        compliance: "Conformité"
                    },
                    hero: {
                        badge: "Technologie Avancée & Logistique Globale",
                        headline: "Autonomiser les Opérations Globales par la Technologie et la Logistique",
                        description_part1: "Bousanm Technology propose un développement de logiciels de bout en bout, une infrastructure e-commerce fluide et des solutions d'expédition robustes.",
                        description_part2: "Adaptées aux marchés émergents, nos solutions assurent fiabilité et évolutivité pour vos besoins commerciaux mondiaux.",
                        waitlist: "Rejoindre la liste d'attente",
                        contact: "Nous Contacter",
                        ukRegistered: "Enregistré au RU",
                        licensed: "Partenaires agréés",
                        secure: "Opérations Globales",
                        cardLabel: "NUMÉRO DE SUIVI",
                        businessName: "BSM-9920-X1"
                    },
                    features: {
                        title: "Nos Services",
                        subtitle: "Autonomiser les Opérations Mondiales grâce à la Technologie et à la Logistique",
                        description: "Bousanm Technology construit les bases de la croissance de votre entreprise grâce à des logiciels personnalisés, du commerce électronique et de la logistique.",
                        sectionTitle: "Services Principaux",
                        card1_title: "Développement de Logiciels",
                        card1_desc: "Nous concevons des solutions d'entreprise sur mesure, des API fintech aux systèmes ERP évolutifs, aidant les entreprises à automatiser leurs opérations de base.",
                        card2_title: "Expédition et Logistique Globale",
                        card2_desc: "Services de messagerie et de fret fiables connectant les États-Unis, l'Amérique latine et les Caraïbes avec un suivi en temps réel.",
                        card3_title: "Solutions E-commerce",
                        card3_desc: "Nous fournissons les outils numériques et l'infrastructure de paiement nécessaires pour que les marques se développent dans les régions à forte croissance.",
                        card4_title: "Opérations Mondiales",
                        card4_desc: "Infrastructure technologique pour gérer et développer vos opérations commerciales partout dans le monde."
                    },
                    whyBousanm: {
                        title: "Pourquoi Bousanm Technology",
                        subtitle: "Conçu pour l'Efficacité, l'Échelle et les Résultats",
                        feature1: "Architecture logicielle sur mesure",
                        feature2: "Infrastructure logistique mondiale",
                        feature3: "Conçu pour les marchés émergents",
                        feature4: "Plateformes sécurisées et évolutives",
                        feature5: "Support technique et opérationnel 24/7",
                        tagline: "Une technologie en laquelle vous pouvez avoir confiance. Une infrastructure conçue pour évoluer."
                    },
                    productOverview: {
                        title: "Bientôt Disponible",
                        subtitle: "Expansion de Notre Écosystème",
                        description: "Nous faisons constamment évoluer notre plateforme pour proposer des fonctionnalités plus avancées à nos clients.",
                        feature1: "Gestion d'entrepôt intégrée",
                        feature2: "Intégrations API avancées",
                        feature3: "Réseau logistique mondial",
                        footer: "Plus de fonctionnalités bientôt disponibles."
                    },
                    whoWeServe: {
                        title: "Nos Clients",
                        subtitle: "Adapté à la Croissance Mondiale",
                        audience1_title: "Entreprises des Marchés Émergents",
                        audience1_desc: "Autonomiser les entreprises locales grâce à des capacités technologiques et logistiques mondiales.",
                        audience2_title: "Marques E-commerce & Startups",
                        audience2_desc: "Une infrastructure évolutive pour lancer et développer votre présence en ligne.",
                        audience3_title: "Entreprises de Logistique & Distribution",
                        audience3_desc: "Moderniser la chaîne d'approvisionnement avec des solutions logicielles basées sur les données."
                    },
                    waitlist: {
                        title: "Commencez Votre Voyage Global Dès Aujourd'hui",
                        description: "Rejoignez notre liste d'accès anticipé et découvrez comment notre technologie peut transformer vos opérations.",
                        emailPlaceholder: "Adresse e-mail",
                        countryPlaceholder: "Pays (optionnel)",
                        button: "Obtenir un Accès Anticipé",
                        privacy: "Nous respectons votre vie privée. Pas de spam.",
                        successTitle: "Bienvenue à bord !",
                        successMessage: "Nous vous contacterons bientôt pour les prochaines étapes."
                    },
                    compliance: {
                        title: "Normes de Fiabilité et de Qualité",
                        description: "Nos opérations reposent sur des bases de sécurité, de transparence et d'excellence.",
                        point1_title: "Protection des Données et Confidentialité",
                        point1_desc: "Vos données professionnelles sont sécurisées grâce à notre cryptage de niveau entreprise.",
                        point2_title: "Logistique Transparente",
                        point2_desc: "Suivi et rapports en temps réel pour tous vos besoins d'expédition.",
                        point3_title: "Audits Techniques Rigoureux",
                        point3_desc: "Tests logiciels et mises à jour de sécurité continus pour garantir la stabilité.",
                        point4_title: "Normes Mondiales",
                        point4_desc: "Respect des meilleures pratiques internationales en matière de développement de logiciels et de logistique.",
                        disclaimerTitle: "Notre Engagement",
                        disclaimer1: "Bousanm Technology est un fournisseur de services et de technologies.",
                        disclaimer2: "Nous collaborons avec des experts locaux et internationaux pour fournir une logistique de premier ordre.",
                        disclaimer3: "Nous nous engageons à autonomiser les marchés émergents par l'innovation."
                    },
                    footer: {
                        subtitle: "Infrastructure Tech & Logistique",
                        description: "Autonomiser les entreprises des marchés émergents avec des solutions logicielles, d'e-commerce et d'expédition de bout en bout.",
                        platform: "Plateforme",
                        legal: "Légal",
                        privacyPolicy: "Politique de Confidentialité",
                        termsOfService: "Conditions d'Utilisation",
                        copyright: "© 2026 Bousanm LLC. Tous droits réservés.",
                        disclaimer: "Bousanm Technology est une société de technologie financière, et non une banque. Les services bancaires sont fournis par nos institutions financières partenaires.",
                        address: "Siège Social : 30 N Gould St Ste R, Sheridan, WY 82801 US",
                        contact: "support@bousanmtechnology.com"
                    },
                    about: {
                        title: "À Propos de Nous",
                        subtitle: "Combler le Fossé des Infrastructures",
                        content: "Bousanm Technology est une entreprise à double siège (USA et UK) dédiée à combler le fossé des infrastructures dans les marchés émergents. Fondée dans le cadre de l'écosystème Zig Investment, nous exploitons des logiciels de pointe pour résoudre des défis logistiques et financiers complexes. Notre mission est de fournir aux entreprises des Caraïbes et de l'Amérique Latine la structure technologique nécessaire pour être compétitives à l'échelle mondiale.",
                        visionTitle: "Vision Globale",
                        visionContent: "Donner aux marques des Caraïbes et d'Amérique Latine les moyens de rivaliser sur la scène mondiale.",
                        techTitle: "Technologie Robuste",
                        techContent: "Des logiciels de pointe résolvant les défis logistiques les plus complexes."
                    }
                }
            },
            es: {
                translation: {
                    seo: {
                        siteTitle: "Bousanm Technology",
                        defaultTitle: "Bousanm Technology - Logística Global y Software",
                        defaultDescription: "Desarrollo de software a medida, infraestructura de comercio electrónico y soluciones logísticas globales para mercados emergentes.",
                        defaultKeywords: "desarrollo de software, logística, envío, comercio electrónico, Caribe, América Latina, mensajería, carga"
                    },
                    nav: {
                        whatWeDo: "Lo que hacemos",
                        overview: "Resumen",
                        whoWeServe: "A quién servimos",
                        aboutUs: "Sobre nosotros",
                        compliance: "Cumplimiento"
                    },
                    hero: {
                        badge: "Tecnología Avanzada y Logística Global",
                        headline: "Empoderando Operaciones Globales a través de Tecnología y Logística",
                        description_part1: "Bousanm Technology ofrece desarrollo de software de extremo a extremo, infraestructura de comercio electrónico fluida y soluciones de envío robustas.",
                        description_part2: "Adaptadas a los mercados emergentes, nuestras soluciones garantizan confiabilidad y escala para sus necesidades comerciales globales.",
                        waitlist: "Unirse a la lista de espera",
                        contact: "Contáctenos",
                        ukRegistered: "Registrado en el Reino Unido",
                        licensed: "Socios con licencia",
                        secure: "Operaciones Globales",
                        cardLabel: "NÚMERO DE SEGUIMIENTO",
                        businessName: "BSM-9920-X1"
                    },
                    features: {
                        title: "Nuestros Servicios",
                        subtitle: "Empoderando Operaciones Globales a través de Tecnología y Logística",
                        description: "Bousanm Technology construye las bases para el crecimiento de su negocio a través de software personalizado, comercio electrónico y logística.",
                        sectionTitle: "Servicios Principales",
                        card1_title: "Desarrollo de Software",
                        card1_desc: "Creamos soluciones empresariales a medida, desde APIs fintech hasta sistemas ERP escalables, ayudando a las empresas a automatizar sus operaciones principales.",
                        card2_title: "Envío y Logística Global",
                        card2_desc: "Servicios confiables de mensajería y transporte de carga que conectan a EE. UU., América Latina y el Caribe con seguimiento en tiempo real.",
                        card3_title: "Soluciones de E-commerce",
                        card3_desc: "Proporcionamos las herramientas digitales y la infraestructura de pagos necesaria para que las marcas escalen en regiones de alto crecimiento.",
                        card4_title: "Operaciones Globales",
                        card4_desc: "Infraestructura impulsada por tecnología para gestionar y escalar sus operaciones comerciales en cualquier parte del mundo."
                    },
                    whyBousanm: {
                        title: "Por qué Bousanm Technology",
                        subtitle: "Construido para la Eficiencia, Escala y Resultados",
                        feature1: "Arquitectura de software personalizada",
                        feature2: "Infraestructura logística global",
                        feature3: "Diseñado para mercados emergentes",
                        feature4: "Plataformas seguras y escalables",
                        feature5: "Soporte técnico y operativo 24/7",
                        tagline: "Tecnología en la que puede confiar. Infraestructura construida para escalar."
                    },
                    productOverview: {
                        title: "Próximamente",
                        subtitle: "Expandiendo Nuestro Ecosistema",
                        description: "Estamos evolucionando constantemente nuestra plataforma para ofrecer funciones más avanzadas a nuestros clientes.",
                        feature1: "Gestión de almacenes integrada",
                        feature2: "Integraciones de API avanzadas",
                        feature3: "Red de cumplimiento global",
                        footer: "Más funciones próximamente."
                    },
                    whoWeServe: {
                        title: "Nuestros Clientes",
                        subtitle: "Adaptado para el Crecimiento Global",
                        audience1_title: "Empresas de Mercados Emergentes",
                        audience1_desc: "Empoderando a negocios locales con capacidades tecnológicas y logísticas mundiales.",
                        audience2_title: "Marcas de E-commerce y Startups",
                        audience2_desc: "Infraestructura escalable para lanzar y hacer crecer su presencia en línea.",
                        audience3_title: "Empresas de Logística y Distribución",
                        audience3_desc: "Modernizando la cadena de suministro con soluciones de software basadas en datos."
                    },
                    waitlist: {
                        title: "Comience Su Viaje Global Hoy",
                        description: "Únase a nuestra lista de acceso anticipado y descubra cómo nuestra tecnología puede transformar sus operaciones.",
                        emailPlaceholder: "Correo electrónico",
                        countryPlaceholder: "País (opcional)",
                        button: "Obtener Acceso Anticipado",
                        privacy: "Respetamos su privacidad. Sin spam.",
                        successTitle: "¡Bienvenidos a bordo!",
                        successMessage: "Nos pondremos en contacto pronto para los siguientes pasos."
                    },
                    compliance: {
                        title: "Estándares de Confiabilidad y Calidad",
                        description: "Nuestras operaciones se basan en una base de seguridad, transparencia y excelencia.",
                        point1_title: "Protección de Datos y Privacidad",
                        point1_desc: "Sus datos comerciales están seguros con nuestro cifrado de nivel empresarial.",
                        point2_title: "Logística Transparente",
                        point2_desc: "Seguimiento e informes en tiempo real para todas sus necesidades de envío.",
                        point3_title: "Auditorías Técnicas Rigurosas",
                        point3_desc: "Pruebas de software y actualizaciones de seguridad continuas para garantizar la estabilidad.",
                        point4_title: "Estándares Globales",
                        point4_desc: "Cumplimiento de las mejores prácticas internacionales en desarrollo de software y logística.",
                        disclaimerTitle: "Nuestro Compromiso",
                        disclaimer1: "Bousanm Technology es un proveedor de servicios y tecnología.",
                        disclaimer2: "Nos asociamos con expertos locales e internacionales para ofrecer una logística de primer nivel.",
                        disclaimer3: "Estamos comprometidos con el empoderamiento de los mercados emergentes a través de la innovación."
                    },
                    footer: {
                        subtitle: "Infraestructura Tech & Logística",
                        description: "Empoderando a las empresas en mercados emergentes con soluciones de software, comercio electrónico y envío de extremo a extremo.",
                        platform: "Plataforma",
                        legal: "Legal",
                        privacyPolicy: "Política de Privacidad",
                        termsOfService: "Términos de Uso",
                        copyright: "© 2026 Bousanm LLC. Todos los derechos reservados.",
                        disclaimer: "Bousanm Technology es una empresa de tecnología financiera, no un banco. Los servicios bancarios son proporcionados por nuestras instituciones financieras asociadas.",
                        address: "Dirección Registrada: 30 N Gould St Ste R, Sheridan, WY 82801 US",
                        contact: "support@bousanmtechnology.com"
                    },
                    about: {
                        title: "Sobre Nosotros",
                        subtitle: "Cerrando la Brecha de Infraestructura",
                        content: "Bousanm Technology es una empresa con doble sede (EE. UU. y el Reino Unido) dedicada a cerrar la brecha de infraestructura en los mercados emergentes. Fundada como parte del ecosistema de Zig Investment, aprovechamos software de vanguardia para resolver desafíos logísticos y financieros complejos. Nuestra misión es proporcionar a las empresas del Caribe y América Latina la columna vertebral tecnológica necesaria para competir globalmente.",
                        visionTitle: "Visión Global",
                        visionContent: "Empoderar a las marcas del Caribe y América Latina para competir en el escenario mundial.",
                        techTitle: "Tecnología Robusta",
                        techContent: "Software de vanguardia que resuelve los desafíos logísticos más complejos."
                    }
                }
            },
            pt: {
                translation: {
                    seo: {
                        siteTitle: "Bousanm Technology",
                        defaultTitle: "Bousanm Technology - Logística Global e Software",
                        defaultDescription: "Desenvolvimento de software sob medida, infraestrutura de e-commerce e soluções logísticas globais para mercados emergentes.",
                        defaultKeywords: "desenvolvimento de software, logística, envio, e-commerce, Caribe, América Latina, correio, carga"
                    },
                    nav: {
                        whatWeDo: "O que fazemos",
                        overview: "Visão geral",
                        whoWeServe: "A quem servimos",
                        aboutUs: "Sobre nós",
                        compliance: "Conformidade"
                    },
                    hero: {
                        badge: "Tecnologia Avançada e Logística Global",
                        headline: "Capacitando Operações Globais através de Tecnologia e Logística",
                        description_part1: "A Bousanm Technology oferece desenvolvimento de software de ponta a ponta, infraestrutura de e-commerce integrada e soluções de transporte robustas.",
                        description_part2: "Adaptadas para mercados emergentes, nossas soluções garantem confiabilidade e escala para suas necessidades globais de negócios.",
                        waitlist: "Entrar na lista de espera",
                        contact: "Entre em Contato",
                        ukRegistered: "Registrado no Reino Unido",
                        licensed: "Parceiros licenciados",
                        secure: "Operações Globais",
                        cardLabel: "NÚMERO DE RASTREIO",
                        businessName: "BSM-9920-X1"
                    },
                    features: {
                        title: "Nossos Serviços",
                        subtitle: "Capacitando Operações Globais através de Tecnologia e Logística",
                        description: "A Bousanm Technology constrói as bases para o crescimento do seu negócio através de software personalizado, e-commerce e logística.",
                        sectionTitle: "Serviços Principais",
                        card1_title: "Desenvolvimento de Software",
                        card1_desc: "Construímos soluções empresariais personalizadas, desde APIs fintech até sistemas ERP escaláveis, ajudando empresas a automatizar as suas operações centrais.",
                        card2_title: "Envio Global e Logística",
                        card2_desc: "Serviços fiáveis de correio e agenciamento de carga que ligam os EUA, a América Latina e as Caraíbas com rastreio em tempo real.",
                        card3_title: "Soluções de E-commerce",
                        card3_desc: "Fornecemos as ferramentas digitais e a infraestrutura de pagamentos necessária para que as marcas cresçam em regiões de alto crescimento.",
                        card4_title: "Operações Globais",
                        card4_desc: "Infraestrutura tecnológica para gerenciar e escalar suas operações de negócios em qualquer lugar do mundo."
                    },
                    whyBousanm: {
                        title: "Por que Bousanm Technology",
                        subtitle: "Construído para Eficiência, Escala e Resultados",
                        feature1: "Arquitetura de software personalizada",
                        feature2: "Infraestrutura logística global",
                        feature3: "Projetado para mercados emergentes",
                        feature4: "Plataformas seguras e escaláveis",
                        feature5: "Suporte técnico e operacional 24/7",
                        tagline: "Tecnologia em que você pode confiar. Infraestrutura construída para escalar."
                    },
                    productOverview: {
                        title: "Em Breve",
                        subtitle: "Expandindo Nosso Ecossistema",
                        description: "Estamos evoluindo constantemente nossa plataforma para trazer recursos mais avançados para nossos clientes.",
                        feature1: "Gestão de armazém integrada",
                        feature2: "Integregrações de API avançadas",
                        feature3: "Rede global de fulfillment",
                        footer: "Mais recursos em breve."
                    },
                    whoWeServe: {
                        title: "Nossos Clientes",
                        subtitle: "Adaptado para Crescimento Global",
                        audience1_title: "Empresas em Mercados Emergentes",
                        audience1_desc: "Capacitando negócios locais com capacidades tecnológicas e logísticas mundiais.",
                        audience2_title: "Marcas de E-commerce e Startups",
                        audience2_desc: "Infraestrutura escalável para lançar e expandir sua presença online.",
                        audience3_title: "Empresas de Logística e Distribuição",
                        audience3_desc: "Modernizando a cadeia de suprimentos com soluções de software baseadas em dados."
                    },
                    waitlist: {
                        title: "Comece Sua Jornada Global Hoje",
                        description: "Junte-se à nossa lista de acesso antecipado e descubra como nossa tecnologia pode transformar suas operações.",
                        emailPlaceholder: "Endereço de e-mail",
                        countryPlaceholder: "País (opcional)",
                        button: "Obter Acesso Antecipado",
                        privacy: "Respeitamos sua privacidade. Sem spam.",
                        successTitle: "Bem-vindo a bordo!",
                        successMessage: "Entraremos em contato em breve com os próximos passos."
                    },
                    compliance: {
                        title: "Padrões de Confiabilidade e Qualidade",
                        description: "Nossas operações são construídas sobre uma base de segurança, transparência e excelência.",
                        point1_title: "Proteção de Dados e Privacidade",
                        point1_desc: "Seus dados comerciais estão seguros com nossa criptografia de nível empresarial.",
                        point2_title: "Logística Transparente",
                        point2_desc: "Rastreamento e relatórios em tempo real para todas as suas necessidades de transporte.",
                        point3_title: "Auditorias Técnicas Rigorosas",
                        point3_desc: "Testes de software contínuos e atualizações de segurança para garantir estabilidade.",
                        point4_title: "Padrões Globais",
                        point4_desc: "Aderindo às melhores práticas internacionais em desenvolvimento de software e logística.",
                        disclaimerTitle: "Nosso Compromisso",
                        disclaimer1: "A Bousanm Technology é um provedor de serviços e tecnologia.",
                        disclaimer2: "Fazemos parcerias com especialistas locais e internacionais para oferecer logística de alto nível.",
                        disclaimer3: "Estamos comprometidos em capacitar mercados emergentes por meio da inovação."
                    },
                    footer: {
                        subtitle: "Infraestrutura de Tecnologia e Logística",
                        description: "Capacitando empresas em mercados emergentes com soluções de software, e-commerce e transporte de ponta a ponta.",
                        platform: "Plataforma",
                        legal: "Legal",
                        privacyPolicy: "Política de Privacidade",
                        termsOfService: "Termos de Uso",
                        copyright: "© 2026 Bousanm LLC. Todos os direitos reservados.",
                        disclaimer: "A Bousanm Technology é uma empresa de tecnologia financeira, não um banco. Os serviços bancários são fornecidos pelas nossas instituições financeiras parceiras.",
                        address: "Endereço Registado: 30 N Gould St Ste R, Sheridan, WY 82801 US",
                        contact: "support@bousanmtechnology.com"
                    },
                    about: {
                        title: "Sobre Nós",
                        subtitle: "Preenchendo a Lacuna de Infraestrutura",
                        content: "A Bousanm Technology é uma empresa com sede dupla (EUA e Reino Unido) dedicada a preencher a lacuna de infraestrutura em mercados emergentes. Fundada como parte do ecossistema Zig Investment, utilizamos software de ponta para resolver desafios logísticos e financeiros complexos. Nossa missão é fornecer às empresas do Caribe e da América Latina a base tecnológica necessária para competir globalmente.",
                        visionTitle: "Visão Global",
                        visionContent: "Capacitando marcas no Caribe e na América Latina para competir no cenário mundial.",
                        techTitle: "Tecnologia Robusta",
                        techContent: "Software de ponta resolvendo os desafios logísticos mais complexos."
                    }
                }
            }
        }
    });

export default i18n;
